import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {
  AuthService,
  PermissionGuardData,
  PermissionValidatorService,
} from '@nomoh-monorepo/data-access-auth';
import { isValidSistemaEnum, SistemaEnum } from '@nomoh-monorepo/shared-types';

export const permissionGuard: CanActivateFn = async (route) => {
  const permissionService = inject(PermissionValidatorService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const data = route.data as PermissionGuardData;

  if (!data || !data.permissions || data.permissions.length === 0) {
    console.warn('PermissionGuard: Nenhuma permissão configurada na rota');
    return true;
  }

  if (authService.$loading()) {
    await waitUntil(() => !authService.$loading());
  }

  if (!authService.$isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  // Garante permissões carregadas (ex.: sessão via cookie sem localStorage de sistema)
  if (!permissionService.$permissionsLoaded()) {
    if (permissionService.$loading()) {
      await waitUntil(() => !permissionService.$loading());
    }

    if (!permissionService.$permissionsLoaded()) {
      const sistema = resolveSistemaFromStorage();
      if (sistema) {
        await permissionService.loadPermissionsForSystem(sistema);
      }
    }
  }

  const requireAll = data.requireAll ?? true;
  const hasPermission = requireAll
    ? permissionService.hasAllPermissions(data.permissions)
    : permissionService.hasAnyPermission(data.permissions);

  if (!hasPermission) {
    console.warn('Acesso negado:', data.permissions);
    router.navigate(['/access-denied']);
    return false;
  }

  return true;
};

function resolveSistemaFromStorage(): SistemaEnum | null {
  try {
    const stored = localStorage.getItem('nomoh_sistema_id');
    if (stored && isValidSistemaEnum(stored)) {
      return stored;
    }
  } catch {
    // ignore
  }
  return SistemaEnum.Nomoh;
}

function waitUntil(predicate: () => boolean): Promise<void> {
  return new Promise((resolve) => {
    const check = () => {
      if (predicate()) resolve();
      else setTimeout(check, 50);
    };
    check();
  });
}
